import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';

export default function ReadStoryButton({ text }) {
  const [reading, setReading] = useState(false);
  const [error, setError] = useState('');
  const utterance = useRef(null);
  const supported = typeof window !== 'undefined' && 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;
  useEffect(() => {
    setReading(false);
    setError('');
    return () => {
      if (utterance.current) {
        utterance.current.onend = null;
        utterance.current.onerror = null;
        window.speechSynthesis.cancel();
        utterance.current = null;
      }
    };
  }, [text]);
  const toggle = () => {
    if (reading) { window.speechSynthesis.cancel(); setReading(false); return; }
    const speech = new SpeechSynthesisUtterance(text);
    speech.lang = /[\u3400-\u9fff]/.test(text) ? 'zh-CN' : document.documentElement.lang || 'en';
    speech.onend = () => setReading(false);
    speech.onerror = event => { setReading(false); if (!['canceled', 'interrupted'].includes(event.error)) setError('朗读暂不可用，请检查浏览器语音支持。'); };
    utterance.current = speech;
    setError(''); setReading(true);
    window.speechSynthesis.speak(speech);
  };
  return <>
    <Button variant="outlined" onClick={toggle} disabled={!supported || !text} aria-pressed={reading} sx={{ color: '#000', borderColor: '#000', borderRadius: '8px', fontSize: '14px' }}>
      {!supported ? '此浏览器不支持朗读' : reading ? '停止朗读' : '朗读故事'}
    </Button>
    {error && <span role="status">{error}</span>}
  </>;
}
